export default "__VITE_ASSET__DfaV9IOk__"